import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import { auth, alert, diag, doc, master, contactForm, trialEntry, user, portal, solution } from './modules';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    auth,
    alert,
    diag,
    doc,
    master,
    contactForm,
    trialEntry,
    user,
    portal,
    solution,
  },
  plugins: [createPersistedState({key: 'ld-app'})],
});

export default store;
